export { default } from "./BookingEdit";
